













import _ from 'lodash'
import { Validator } from 'vee-validate'
import Vue from 'vue'

import { Component, Inject, Prop } from 'vue-property-decorator'

import { regionMap } from '../../services/region'
import SpaSelect from '../atoms/DropdownSelect.vue'
import { SelectItem } from '../atoms/model/SelectItem'

@Component({
  components: {
    SpaSelect,
  },
})
export default class PrefecutreSelectBox extends Vue {
  @Inject()
  $validator: Validator

  @Prop()
  value: string

  @Prop()
  validate: any

  @Prop({ default: false })
  disabled: boolean

  @Prop({ default: 'prefecture' })
  name: string

  get prefecturesSelectList(): SelectItem[] {
    return [
      {
        text: '都道府県',
        value: '',
        selected: _.isEmpty(this.value),
        disabled: true,
      },
      ..._.map(regionMap, (name, id) => ({
        id,
        name,
      })).map(item => ({
        text: item.name,
        value: item.id,
        selected: item.id === this.value,
        disabled: false,
      })),
    ]
  }

  onInput(selected) {
    this.$emit('input', selected)
  }
}
